/**
 * Operational sidebar: menu sections and links are gated by permission name strings from
 * getStoredPermissions() (backend role PERMISSIONS, e.g. "DSR", "Day Close", "All Reports").
 * Owner role bypasses some report entries via isOwnerRole().
 */
import { Component } from "react";
import logo from '../../img/logo.svg';
import { isOwnerRole } from "../../utils/ownerRole";
import avatar from '../../img/avatar.svg'
import dashboard from '../../img/dashboard.png'
import settings from '../../img/settings.png'
import user from '../../img/operation.png'
import operation from '../../img/operation.png'
import activity from '../../img/activity.png'
import fuelstation from '../../img/fuel-station.png'
import purchasing from '../../img/purchasing.png'
import dispenser from '../../img/dispenser.png'
import fueltruck from '../../img/fuel-truck.png'
import scale from '../../img/scale.png'
import fuel from '../../img/fuel.png'
import tank from '../../img/tank.png'
import { Link, useLocation } from "react-router-dom";
import { useState, useRef, useLayoutEffect } from 'react';
import { useEffect } from 'react';
import { WEB_URL } from "../../constant/API_Settings"
import { getStoredPermissions } from "../../utils/permissions";
import { openLegacyReportsPortal } from "../../utils/legacyReports";

import { API_URL } from "../../constant/API_Settings"
import { persistSubscriptionAccess, isPaidSubscriptionExpired, needsSubscriptionPlan } from "../../utils/subscriptionAccess"
import SubscriptionExpiredSidebarNotice from "./SubscriptionExpiredSidebarNotice"

function SidebarMenuToggle({ className = "", onClick, children }) {
  return (
    <button
      type="button"
      className={`sidebar-menu-toggle ${className}`.trim()}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

const SIDEBAR_SEARCH_HIDDEN_CLASS = "sidebar-search-hidden";

function sidebarMenuItemLabel(item) {
  const clone = item.cloneNode(true);
  clone.querySelectorAll("ul").forEach((list) => list.remove());
  return (clone.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
}

function sidebarMenuAncestorMatches(item, menuRoot, query) {
  let parent = item.parentElement;
  while (parent && parent !== menuRoot) {
    if (parent.tagName === "LI" && sidebarMenuItemLabel(parent).includes(query)) {
      return true;
    }
    parent = parent.parentElement;
  }
  return false;
}

function sidebarMenuItemMatches(item, query) {
  if (sidebarMenuItemLabel(item).includes(query)) {
    return true;
  }
  return Array.from(item.querySelectorAll("li")).some((child) =>
    sidebarMenuItemLabel(child).includes(query)
  );
}

/**
 * Hide menu rows that do not match the query. A matching parent stays visible
 * with its children. A matching child keeps its parent groups visible.
 * Returns true when the query is non-empty and nothing matches.
 */
function applySidebarMenuFilter(menuRoot, query) {
  if (!menuRoot) {
    return false;
  }

  const normalized = query.trim().toLowerCase();
  const items = Array.from(menuRoot.querySelectorAll("li"));
  if (!normalized) {
    items.forEach((item) => item.classList.remove(SIDEBAR_SEARCH_HIDDEN_CLASS));
    return false;
  }

  let hasMatch = false;
  items.forEach((item) => {
    const visible = sidebarMenuAncestorMatches(item, menuRoot, normalized)
      || sidebarMenuItemMatches(item, normalized);
    item.classList.toggle(SIDEBAR_SEARCH_HIDDEN_CLASS, !visible);
    if (visible && sidebarMenuItemLabel(item)) {
      hasMatch = true;
    }
  });

  return !hasMatch;
}

const OPERATIONS_PATH_PREFIXES = [
  "/dashboard",
  "/operational-date",
  "/operational-dates",
  "/op-fuelunloading",
  "/nozzle-employee-list",
  "/nozzle-closing",
  "/nozzle-report",
  "/nonfuel-product-direct",
  "/gas_cylinder_sales",
  "/oil-barrel-sales",
  "/loose-oil-machine",
  "/nonfuel-product-purchase",
  "/gas_cylinder_purchase",
  "/product-transfer-rack",
  "/op-dsr-report",
  "/op-density-report",
  "/NonFuel-product-Selling-Price-Change",
  "/day-closing",
  "/op-fuel-edit",
  "/fuel-sell-price",
  "/credit-sales",
  "/recoup",
  "/expense",
  "/cashpayment",
  "/ReceiptVoucher",
  "/closepayment",
];

const Operational_Sidebar_Progress = (progress, operation) => {

  const location_details = useLocation()
  let permissions = getStoredPermissions();


  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)
  const [show2, setShow2] = useState(false)
  const [show3, setShow3] = useState(false)
  const [show4, setShow4] = useState(false)
  const [show5, setShow5] = useState(false)
  const [show6, setShow6] = useState(false)
  const [show7, setShow7] = useState(false)
  const [show8, setShow8] = useState(false)
  // console.log(progress)
  useEffect(() => {
    check_meta_date();
    fetchOwnerStatus();
    syncSidebarMeta();
  }, []);

  function syncSidebarMeta() {
    const token = localStorage.getItem("AUTH_TOKEN");
    if (!token) {
      return;
    }

    fetch(`${API_URL}/getSidebar`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        persistSubscriptionAccess(responseData || {})
        setShowRenewNotice(isPaidSubscriptionExpired())
        setShowSubscribeNotice(needsSubscriptionPlan())
        if (responseData?.stat_operation) {
          localStorage.setItem("STAT_OPERATION", responseData.stat_operation);
        }
        if (responseData?.lastScreenName) {
          localStorage.setItem("LAST_SCREEN", responseData.lastScreenName);
        }
      })
      .catch(() => {});
  }

  useEffect(() => {
    if (location_details.pathname.startsWith('/other-reports/')) {
      setShow2(true);
      setShow8(true);
      setShow3(false);
      setShow4(false);
      setShow5(false);
    }
  }, [location_details.pathname]);

  useEffect(() => {
    const path = location_details.pathname;
    if (OPERATIONS_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))) {
      setShow(true);
    }
  }, [location_details.pathname]);

  function fetchOwnerStatus() {
    const requestOptions = {
      method: 'get',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json",
      },
    };
    fetch(`${API_URL}/is_owner`, requestOptions)
      .then((response) => response.json())
      .then((roleName) => {
        setIsOwner(isOwnerRole(roleName));
      })
      .catch(() => {});
  }

  function check_meta_date() {

    const requestOptions = {
      method: 'post',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json"

      }
    };
    fetch(`${API_URL}/check_meta_date`, requestOptions)
      .then(response => { return response.json(); })
      .then(responseData => {
        setUser({ user_id: responseData.userId })
        if (responseData.owner) {
          setIsOwner(isOwnerRole(responseData.owner));
        }

        return responseData;
      })
      .catch(e => {
      });

  }
  function toggle() {
    setShow(!show)
    setShow1(false)
    setShow2(false)
    setShow4(false)
    setShow5(false)
    setShow3(false)
    setShow6(false)
  }
  function toggle1() {
    setShow1(!show1)
    setShow(false)
    setShow2(false)
    setShow4(false)
    setShow5(false)
    setShow3(false)
    setShow6(false)
    setShow8(false)
  }
  function toggle2() {
    setShow2(!show2)
    setShow(false)
    setShow1(false)
    setShow4(false)
    setShow5(false)
    setShow3(false)
    setShow6(false)
    setShow8(false)
  }
  function toggle3() {
    setShow3(!show3)
    setShow(false)
    setShow1(false)
    setShow4(false)
    setShow5(false)
    setShow6(false)
    setShow8(false)
  }
  function toggle4() {
    setShow3(false)
    setShow(false)
    setShow1(false)
    setShow4(!show4)
    setShow5(false)
    setShow6(false)
    setShow8(false)
  }
  function toggle5() {
    setShow3(false)
    setShow(false)
    setShow1(false)
    setShow4(false)
    setShow5(!show5)
    setShow6(false)
    setShow8(false)
  }
  function toggle6() {
    setShow3(false)
    setShow(false)
    setShow2(false)
    setShow1(false)
    setShow4(false)
    setShow5(false)
    setShow6(!show6)
    setShow8(false)
  }
  function toggle8() {
    setShow3(false)
    setShow(false)
    setShow1(false)
    setShow4(false)
    setShow5(false)
    setShow6(false)
    setShow8(!show8)
  }
  const [user, setUser] = useState()
  const [isOwner, setIsOwner] = useState(false)
  const [userName, setUserName] = useState(localStorage.getItem("PROFILE_NAME"))
  const [showRenewNotice, setShowRenewNotice] = useState(() => isPaidSubscriptionExpired())
  const [showSubscribeNotice, setShowSubscribeNotice] = useState(() => needsSubscriptionPlan())
  const showSubscriptionAction = showRenewNotice || showSubscribeNotice
  const [menuQuery, setMenuQuery] = useState("")
  const [menuSearchMiss, setMenuSearchMiss] = useState(false)
  const menuRef = useRef(null)
  const menuSearchActive = menuQuery.trim() !== ""

  useLayoutEffect(() => {
    const missed = applySidebarMenuFilter(menuRef.current, menuQuery)
    setMenuSearchMiss(missed)
  })
  return (
    <div className="left-wrap p-0">

      <div className="d-flex">
        <div className="logo-wrp">
          <a className="logo-continer text-center" href="/dashboard" onClick={(event) => event.preventDefault()}>
            <img src={logo} alt="Petrosmart" />
          </a>
        </div>
        <div className="d-md-none pe-4 ms-auto">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">

            <li className="nav-item dropdown notify">
              <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <img src="img/bell-white.svg" width="20px;" />
                <span className="badge bg-danger">2</span>
              </a>
              <ul className="dropdown-menu notification shadow" aria-labelledby="navbarDropdown">
                <li><h4 className="notify-head">Notification 1</h4></li>
                <li><a className="dropdown-item" href="#"><strong>Lorem Ipsum</strong><span>Lorem Ipsum is simply dummy text of the printing</span><small>2 day ago</small></a></li>
                <li><a className="dropdown-item" href="#"><strong>Lorem Ipsum</strong><span>Lorem Ipsum is simply dummy text of the printing</span><small>2 day ago</small></a></li>
                <li><a className="dropdown-item text-center notify-all" href="#">show all notifications</a></li>
              </ul>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle user-head" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <img className="img-profile rounded-circle" src="img/avatar.svg" />{userName}<span><i className="fa fa-angle-down font-weight-bolder" aria-hidden="true"></i></span>
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                {/* <li><a className="dropdown-item" href="#">Profile</a></li>
                <li><Link to="/operational-settings" className="dropdown-item">Settings</Link></li>
                <li><hr className="dropdown-divider" /></li> */}
                <li><Link className="dropdown-item" to="/logout">Logout</Link></li>
              </ul>
            </li>

          </ul>
        </div>
      </div>
      <div className="responsive">
        <div className="profile-pic" style={{ display: 'none' }} >
          <img src={avatar} className="img-fluid" />
        </div>

      </div>

      <SubscriptionExpiredSidebarNotice
        visibleExpired={showRenewNotice}
        visibleRequired={showSubscribeNotice}
      />

      <div className="sidebar-menu-search">
        <input
          type="search"
          className="form-control form-control-sm"
          placeholder="Search menu"
          aria-label="Search menu"
          value={menuQuery}
          autoComplete="off"
          onChange={(event) => setMenuQuery(event.target.value)}
        />
      </div>
      {menuSearchMiss ? (
        <p className="sidebar-menu-search-empty">No menu items found</p>
      ) : null}

      <ul className="sidemenu" ref={menuRef}>
        {showSubscriptionAction ? (
          <li className="sidebar-sub-expired-item">
            <Link to="/subscription-management?tab=purchase">
              <span>
                <p>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z" />
                  </svg>
                  <span className="ms-2">{showRenewNotice ? "Renew subscription" : "Choose a subscription"}</span>
                </p>
              </span>
            </Link>
          </li>
        ) : null}
        {permissions.includes("Dashboard") == true ?
          <li className={progress.progress == 22 ? "active" : ""} ><Link to="/dashboard" onClick={(event) => { if (location_details.pathname === "/dashboard") event.preventDefault(); }}><p> <img src={dashboard} className="img-fluid " /> <span className="ms-2 text-white" >Dashboard</span></p></Link> </li>
          : ''}
        {!permissions.includes("Deny Pump Details") ?
          <li className={location_details.pathname === "/pump-details" ? "active" : ""}>
            <Link to="/pump-details">
              <p>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-fuel-pump" viewBox="0 0 16 16">
                  <path d="M3 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5Z" />
                  <path d="M1 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2V2Zm13 2v5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1Z" />
                </svg>
                <span className="ms-2 text-white">Pump Details</span>
              </p>
            </Link>
          </li>
          : ''}
        <li className={progress.operation == 1 ? "active" : ""}>
          <SidebarMenuToggle onClick={toggle}>
            <p >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-arrow-repeat" viewBox="0 0 16 16">
              <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
              <path fillRule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
            </svg>

            <span className="ms-2 text-white" >Operations</span></p>
          </SidebarMenuToggle>
          {(show || menuSearchActive) &&
            <ul className="sidesubmenu">

              {permissions.includes("Fuel Price change") || permissions.includes("FuelPricechange-create") || permissions.includes("FuelPricechange-edit") ?
                <>
                  {progress.progress == 1 ?

                    <li className=" active" >

                      <Link to={"/operational-date"}><p className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Fuel Selling Price Change</p></Link>
                    </li> :
                    <li className="" >
                      <Link to={"/operational-date"}><p className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Fuel Selling Price Change</p></Link></li>
                  }

                  {
                    progress.progress == 100 ?
                      <li className=" active" >
                        <Link to={"/operational-dates"}><p className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Operation date</p></Link>
                      </li> :
                      <li className="" >
                        <Link to={"/operational-dates"}><p className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Operation date</p></Link>
                      </li>
                  }
                </>


                : ''}

              {permissions.includes("Fuel Unloading") == true ?
                <li className={progress.progress == 0 ? " active" : ""}>
                  <Link to={"/op-fuelunloading"} className="hai"><p className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Fuel Purchase And Unloading</p></Link>
                </li>
                : ''}
              <li className={progress.progress == 25 ? " active" : ""}>
                <Link to={"/nozzle-employee-list"} className="hai"><p
                  className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Employee Closing</p></Link>
              </li>
              {permissions.includes("Fuel Unloading") == true ?
                <li className={progress.progress == 27 ? " active" : ""}>
                  <Link to={"/nonfuel-product-direct"} className="hai"><p
                    className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Non Fuel Direct Sales</p></Link>
                </li>
                : ''}

                {permissions.includes("Fuel Unloading") == true ?
                <li className={progress.progress == 20 ? " active" : ""}>
                  <Link to={"/gas_cylinder_sales"} className="hai"><p
                    className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Gas Cylinder Sales</p></Link>
                </li>
                : ''}

              {permissions.includes("Fuel Unloading") == true ?
                <li className={progress.progress == 26 ? " active" : ""}>
                  <Link to={"/oil-barrel-sales"} className="hai"><p
                    className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Oil Barrel Sales</p></Link>
                </li>
                : ''}
                   {permissions.includes("Fuel Unloading") == true ?
                <li className={progress.progress == 31 ? " active" : ""}>
                  <Link to={"/loose-oil-machine"} className="hai"><p
                    className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Oil-Barrel stock transfer to machine</p></Link>
                </li>
                : ''}

              {!permissions.includes("Customer Attendant") ?
                permissions.includes("Non Fuel Product Direct Sales") == true ?
                  <li className={progress.progress == 8 ? " active" : ""}>
                    <Link to={"/nonfuel-product-purchase"} className="hai"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Non Fuel Purchase</p> </Link>
                  </li>
                  : '' : ''}
                    {!permissions.includes("Customer Attendant") ?
                permissions.includes("Non Fuel Product Direct Sales") == true ?
                  <li className={progress.progress == 29 ? " active" : ""}>
                    <Link to={"/gas_cylinder_purchase"} className="hai"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Gas Cylinder Purchase</p> </Link>
                  </li>
                  : '' : ''}
{/* 
{!permissions.includes("Customer Attendant") ?
                permissions.includes("Non Fuel Product Direct Sales") == true ?
                  <li className={progress.progress == 8 ? " active" : ""}>
                    <Link to={"/gas_cylinder_sales"} className="hai"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Gas Cylinder Sales</p> </Link>
                  </li>
                  : '' : ''} */}

              {permissions.includes("Product Transfer To Rack") || permissions.includes("Rack Configuration") ?
                <li className={progress.progress == 2 ? " active" : ""}>
                  <Link to={"/product-transfer-rack"} className="hai"><p
                    className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Product  To Rack</p></Link>
                </li>
                : ''}

              {permissions.includes("DSR") == true ?
                <li className={progress.progress == 3 ? " active" : ""}>
                  <Link to={"/op-dsr-Report"} className="hai"><p
                    className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>DSR</p></Link>
                </li>
                : ''}
              {permissions.includes("Density") == true ?
                <li className={progress.progress == 4 ? " active" : ""}>
                  <Link to={"/op-density-Report"} className="hai"><p
                    className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Density</p></Link>
                </li>
                : ''}
              {permissions.includes("Return Goods of Non Fuel Products") == true ?
                <li className={progress.progress == 5 ? " active" : ""} >
                  {/* <Link to={"/purchase-return-non-fuel"} className="hai"><p
                    className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Purchase Return of Non Fuel</p></Link> */}
                </li>
                : ''}
              {permissions.includes("Non Fuel Product Price Change") == true ?
                <li className={progress.progress == 6 ? " active" : ""}>
                  <Link to={"/NonFuel-product-Selling-Price-Change"} className="hai"><p
                    className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Non Fuel Selling Price Change</p></Link>
                </li>
                : ''}
              {permissions.includes("Day Close") == true ?
                <li className={progress.progress == 10 ? " active" : ""}>
                  <Link to={location => ({ backpage: location_details.pathname, pathname: "/day-closing" })} className="hai"><p
                    className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Day Closing</p></Link>
                </li>
                : ''}
              {/* {permissions.includes("Edit Fuel Configuration") == true ?
                <li className={progress.progress == 30 ? " active" : ""}>
                  <Link to={"/op-fuel-edit"} className="hai"><p className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Edit Fuel Configuration</p></Link>
                </li>
                : ''} */}

            </ul>
          }
        </li>

        {!permissions.includes("Customer Attendant") ?
          permissions.includes("Payment Voucher") || permissions.includes("Receipt Voucher") || permissions.includes("Account to Account Transfer") ?
            <>
              <li className={progress.operation == 2 ? "active" : ""}><SidebarMenuToggle className="text-white" onClick={toggle1}>
                <p>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-bank2" viewBox="0 0 16 16">
                    <path d="M8.277.084a.5.5 0 0 0-.554 0l-7.5 5A.5.5 0 0 0 .5 6h1.875v7H1.5a.5.5 0 0 0 0 1h13a.5.5 0 1 0 0-1h-.875V6H15.5a.5.5 0 0 0 .277-.916l-7.5-5zM12.375 6v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zM8 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM.5 15a.5.5 0 0 0 0 1h15a.5.5 0 1 0 0-1H.5z" />
                  </svg>

                  <span className="ms-2" href="#">  Accounts</span></p>
          </SidebarMenuToggle>
                {(show1 || menuSearchActive) &&
                  <ul className="sidesubmenu">
                    {permissions.includes("Payment Voucher") == true ?
                      <li className={progress.progress == 11 ? " active" : ""}>
                        <Link to={"/payment"} className="hai"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Payment Voucher</p></Link>
                      </li>
                      : ''}
                    {permissions.includes("Receipt Voucher") == true ?
                      <li className={progress.progress == 12 ? " active" : ""}>
                        <Link to={"/receipt"} className="hai"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Receipt Voucher</p></Link>
                      </li>
                      : ''}
                    {permissions.includes("Account to Account Transfer") == true ?
                      <li className={progress.progress == 13 ? " active" : ""}>
                        <Link to={"/account-to-account-transfer"} className="hai"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>A/c To A/c Transfer</p></Link>
                      </li>
                      : ''}
                  </ul>
                }
              </li>
            </>
            : '' : ''}

        <ul>
          {
            permissions.includes("Fuel Price change") || permissions.includes("FuelPricechange-create") || permissions.includes("FuelPricechange-edit") ?
              <>
                <li><Link to="/stock-gain-loss" className="side-m"><p> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-file-earmark-spreadsheet-fill" viewBox="0 0 16 16">
                  <path d="M6 12v-2h3v2H6z" />
                  <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM3 9h10v1h-3v2h3v1h-3v2H9v-2H6v2H5v-2H3v-1h2v-2H3V9z" />
                </svg> <span className="ms-2 text-white" >Stock Gain or Loss</span></p></Link>
                </li>
              </>
              : ''
          }
        </ul>

        {(permissions.includes("All Reports") == true || isOwner) ?
          <li className=""><SidebarMenuToggle onClick={toggle2}>
            <p>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-file-earmark-spreadsheet-fill" viewBox="0 0 16 16">
                <path d="M6 12v-2h3v2H6z" />
                <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM3 9h10v1h-3v2h3v1h-3v2H9v-2H6v2H5v-2H3v-1h2v-2H3V9z" />
              </svg>

              <span className="ms-2"> Reports</span></p>
          </SidebarMenuToggle>
            {(show2 || menuSearchActive) &&
              <ul className="sidesubmenu">
                <li>
                  <SidebarMenuToggle onClick={toggle3} className="let"><p>
                    <span className="ms-3"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Operation Reports</span></p>
          </SidebarMenuToggle>
                  {show3 || menuSearchActive || progress.operation == 3 ?
                    <ul className="sidesubmenu">
                      {/* Operation Reports — alphabetical */}
                      <li className={progress.progress == 14 ? "  active" : ""}>
                        <Link to="/daily-transaction-sheet"><p className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Daily Transaction</p></Link>
                      </li>
                      {permissions.includes("Employee Worksheet") == true ?
                        <li className={progress.progress == 9 ? "  active" : ""} >
                          <Link to={"/op-worksheet"}><p className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Employee Worksheet</p></Link></li> : ""}
                      <li>
                        <Link to="/fleetcard-statement" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Fleet Card Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/mla-coupon-statement" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>MLA Coupon</p></Link>
                      </li>
                      <li>
                        <Link to="/nonfuel-purchase-report" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Non-Fuel Purchase Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/nonfuel-sales-report" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Non-Fuel Sales Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/nonfuel-stock-statement" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Non-Fuel Stock Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/nozzle-report" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Nozzle Report</p></Link>
                      </li>
                      <li>
                        <Link to="/looseoil-barrel-sales-report" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Loose Oil & Barrel Sales</p></Link>
                      </li>
                      <li>
                        <Link to="/short-excess-report" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Short Statement</p></Link>
                      </li>
                      <li className="">
                        <Link to="/stock-gain-loss"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Stock Gain/Loss</p></Link>
                      </li>
                      <li>
                        <Link to={"/op-fuelunloading"} className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Unload History</p></Link>
                      </li>
                    </ul>
                    : <a onClick={() => setShow3(show3)}></a>}
                </li>

                <li className="">
                  <SidebarMenuToggle onClick={toggle4} className="text-white let"><p>
                    <span className="ms-3">
                      <i className="fa fa-angle-double-right " aria-hidden="true"></i> Financial Reports</span></p>
          </SidebarMenuToggle>
                  {show4 || menuSearchActive || progress.operation == 4 ?

                    <ul className="sidesubmenu">
                      {/* Financial Reports — alphabetical */}
                      <li className={progress.progress == 28 ? "active" : ""}>
                        <Link to="/op-simplified-balance-sheet"  className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Balance Sheet</p></Link>
                      </li>
                      <li>
                        <Link to="/bank-statement" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Bank Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/customer-statement" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Customer Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/dealer-statement" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Dealer Statement</p></Link>
                      </li>
                      {isOwner ? (
                        <li className={progress.progress == 29 ? "active" : ""}>
                          <Link to="/op-financial-statements" className="side-m"><p
                            className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Financial Statements (B/S &amp; P&amp;L)</p></Link>
                        </li>
                      ) : null}
                      {(isOwner || permissions.includes("All Reports")) ? (
                        <li>
                          <Link to="/statutory-filing-reports" className="side-m"><p
                            className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>GST Filing Report</p></Link>
                        </li>
                      ) : null}
                      <li>
                        <Link to="/other-income-report" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Other Income Head Report</p></Link>
                      </li>
                      <li>
                        <Link to="/statement-of-account" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Statement of Account</p></Link>
                      </li>
                      <li className={progress.progress == 26 ? "active" : ""}>
                        <Link to="/trade-profit-loss" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Trade Profit &amp; Loss</p></Link>
                      </li>
                    </ul>
                    : <a onClick={() => setShow4(show4)}></a>}
                </li>

                <li className="">
                  <SidebarMenuToggle onClick={toggle8} className="text-white let"><p>
                    <span className="ms-3">
                      <i className="fa fa-angle-double-right " aria-hidden="true"></i> Other Reports</span></p>
          </SidebarMenuToggle>
                  {(show8 || menuSearchActive) ?
                    <ul className="sidesubmenu">
                      {/* Other Reports — alphabetical */}
                      <li>
                        <Link to="/other-reports/alltransactions" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>All Transactions</p></Link>
                      </li>
                      <li>
                        <Link to="/other-reports/bag_statement" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Bag Collection Report</p></Link>
                      </li>
                      <li>
                        <Link to="/other-reports/bank_statement" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Bank Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/other-reports/closing_cash_statement" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Closing Cash Report</p></Link>
                      </li>
                      <li>
                        <Link to="/other-reports/vehicle_statements" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Customer Vehicle Wise Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/other-reports/exp_statement" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Expense Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/other-reports/fuel_purchase" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Fuel Purchase Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/other-reports/fuel_sales" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Fuel Sales Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/recoup-statement" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Recoup Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/other-reports/gas_purchase" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Gas Purchase Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/other-reports/gas_sales" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Gas Sales Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/other-reports/gas_stock" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Gas Stock Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/other-reports/gst_setoff" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>GST SETOFF Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/other-reports/nozzle_report" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Nozzle Report</p></Link>
                      </li>
                      <li>
                        <Link to="/other-reports/other_income_statement" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Other Income Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/other-reports/ownerfunds_statement" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Owners Fund Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/other-reports/stock_report" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Stock Gain/Loss Statement</p></Link>
                      </li>
                      <li>
                        <Link to="/other-reports/fuel_ps" className="side-m"><p
                          className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Tankwise Purchase Sales Statement</p></Link>
                      </li>
                    </ul>
                    : <a onClick={() => setShow8(show8)}></a>}
                </li>

                <li className="">
                  <button
                    type="button"
                    className="text-white let side-m border-0 bg-transparent w-100 text-start"
                    onClick={() => {
                      openLegacyReportsPortal();
                    }}
                  >
                    <p>
                      <span className="ms-3">
                        <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                        Legacy Reports
                      </span>
                    </p>
                  </button>
                </li>

                <li className=""><SidebarMenuToggle onClick={toggle5} className="text-white let"><p>
                  <span className="ms-3"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Configuration Report</span></p>
          </SidebarMenuToggle>
                  {(show5 || menuSearchActive) ?
                    <ul className="sidesubmenu">
                      {/* Configuration Report — alphabetical */}
                      <li>
                        <Link to={location => ({ backpage: location_details.pathname, pathname: "/cbalance-sheet/cbalance-sheet" })} className="side-m">
                          <p className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Configuration Balance Sheet</p></Link>
                      </li>
                      <li>
                        <Link to={location => ({ backpage: location_details.pathname, pathname: "/fuel-config-report/fuel" })} className="side-m">
                          <p className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Fuel Configuration Report</p></Link>
                      </li>
                      <li>
                        <Link to={location => ({ backpage: location_details.pathname, pathname: "/config-report/config-report" })} className="side-m">
                          <p className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Non-Fuel Configuration Report</p></Link>
                      </li>
                    </ul>


                    : <a onClick={() => setShow5(show5)}></a>}
                </li>

              </ul>

            }
          </li>
          : ''}
        {permissions.includes("Add Remove Parties") == true ?
          <>
            <li className=""><SidebarMenuToggle onClick={toggle6} className="text-white let"> <p>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-file-earmark-spreadsheet-fill" viewBox="0 0 16 16">
                <path d="M6 12v-2h3v2H6z" />
                <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM3 9h10v1h-3v2h3v1h-3v2H9v-2H6v2H5v-2H3v-1h2v-2H3V9z" />
              </svg>

              <span className="ms-2">Add/Remove/Edit Account Heads</span></p>
          </SidebarMenuToggle>
              {(show6 || menuSearchActive) ?
                <ul className="sidesubmenu">
                  <li>
                    <Link to={location => ({ backpage: location_details.pathname, pathname: "/customers/credit-sales" })} className="side-m"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Customer Settings</p></Link>
                  </li>
                  <li>
                    <Link to={location => ({ backpage: location_details.pathname, pathname: "/creditor-debitor/creditor-debitor" })} className="side-m"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Creditor/ Debtor Settings</p></Link>
                  </li>
                  {/* <li>
                      <Link to={"/users"} className="side-m"><p
                         className="ms-5">Employee Settings</p></Link>
                    </li> */}
                  <li>
                    <Link to={location => ({ backpage: location_details.pathname, pathname: "/vendor-config/nf-purchase" })} className="side-m"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Vendor Settings</p></Link>
                  </li>
                  <li>
                    <Link to={location => ({ backpage: location_details.pathname, pathname: "/digital-payment/digital-payment" })} className="side-m"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Digital Payment</p></Link>
                  </li>
                  <li>
                    <Link to={location => ({ backpage: location_details.pathname, pathname: "/bank-opening/bank-opening" })} className="side-m"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Bank Settings</p></Link>
                  </li>
                  <li>
                    <Link to={location => ({ backpage: location_details.pathname, pathname: "/products/products" })} className="side-m"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Non Fuel products</p></Link>
                  </li>
                  <li>
                    <Link to={location => ({ backpage: location_details.pathname, pathname: "/loose-oil-config/loose-oil-config" })} className="side-m"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Loose Oil Products</p></Link>
                  </li>
                  <li>
                    <Link to={location => ({ backpage: location_details.pathname, pathname: "/Productsconfig/Productsconfig" })} className="side-m"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Gas Cylinder Products</p></Link>
                  </li>
                  <li>
                    <Link to={location => ({ backpage: location_details.pathname, pathname: "/rack-config/rack-config" })} className="side-m"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Rack</p></Link>
                  </li>
                  <li>
                    <Link to={location => ({ backpage: location_details.pathname, pathname: "/fleet-card-config/fleet-card-config" })} className="side-m"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Fleetcard Configuration</p></Link>
                  </li>
                  <li>
                    <Link to={location => ({ backpage: location_details.pathname, pathname: "/MLA-coupon/MLA-coupon" })} className="side-m"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>MlaCoupon Configuration</p></Link>
                  </li>
                  <li>
                    <Link to={location => ({ backpage: location_details.pathname, pathname: "/owntanker-config/owntanker-config" })} className="side-m"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Own Tanker Configuration</p></Link>
                  </li>
                  <li>
                    <Link to={location => ({ backpage: location_details.pathname, pathname: "/tanker-income/tanker-income" })} className="side-m"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Tanker Income</p></Link>
                  </li>
                  <li>
                    <Link to={location => ({ backpage: location_details.pathname, pathname: "/tanker-expense/tanker-expense" })} className="side-m"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Tanker Expense</p></Link>
                  </li>
                  {/* <li>
                    <Link to={location => ({ backpage: location_details.pathname, pathname: "/assets/assets" })} className="side-m"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Machineries / Assets</p></Link>
                  </li> */}
                  <li>
                    <Link to={location => ({ backpage: location_details.pathname, pathname: "/other-income/other-income" })} className="side-m"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Other Income Config</p></Link>
                  </li>
                  <li>
                    <Link to={location => ({ backpage: location_details.pathname, pathname: "/expenses/expenses" })} className="side-m"><p
                      className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Expense Head</p></Link>
                  </li>




                </ul>
                : <a onClick={() => setShow6(show6)}></a>}
            </li>
          </>
          : ''}



        {permissions.includes("Task And Reminders") == true ?
          <li >
            <Link to={location => ({ backpage: location_details.pathname, pathname: "/task-config/task-config" })}>
              <span>
                <p>

                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-list-task" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2zM3 3H2v1h1V3z" />
                    <path d="M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9z" />
                    <path fillRule="evenodd" d="M1.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7zM2 7h1v1H2V7zm0 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H2zm1 .5H2v1h1v-1z" />
                  </svg><span className="ms-2">TASK AND REMINDERS</span></p></span></Link>
          </li>
          : ''}

        {permissions.includes("User Management") == true ?
          <li className={progress.progress == 20 ? "active" : ""}>
            <Link to={"/user-management-op"}>
              <span>
                <p>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                    <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z" />
                  </svg><span className="ms-2">User Management</span>
                </p></span></Link>
          </li>
          : ''}
           

        {permissions.includes("Notification Settings") == true ?
          <li className={progress.progress == 23 ? "active" : ""}>
            <Link to={"/notification-setting"}>
              <span>
                <p>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-bell" viewBox="0 0 16 16">
                    <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z" />
                    <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z" />
                  </svg><span className="ms-2">Notification Settings</span>
                </p></span></Link>
          </li>
          : ''}

        {(permissions.includes("Subscription Management") == true || showSubscriptionAction) ?
          <li className={`${progress.progress == 21 ? "active" : ""} ${showSubscriptionAction ? "sidebar-sub-expired-item" : ""}`}>
            <Link to={"/subscription-management?tab=purchase"}>
              <span>
                <p><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-bookmark-fill" viewBox="0 0 16 16">
                  <path d="M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z" />
                </svg><span className="ms-2">{showRenewNotice ? "Renew subscription" : (showSubscribeNotice ? "Choose a subscription" : "Subscription Management")}</span></p></span></Link>
          </li>
          : ''}
          {permissions.includes("Generate Invoice") == true ?
          <li className={progress.progress == 22 ? "active" : ""}>
            <Link to={"/invoice-settings"}>
              <span>
                <p>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" viewBox="0 0 24 24">
  <path d="M22.683 9.394l-1.88-.239a9.45 9.45 0 0 0-.569-1.374l1.161-1.495a1.486 1.486 0 0 0-.122-1.979l-1.575-1.575a1.49 1.49 0 0 0-1.985-.127L16.22 3.766a9.416 9.416 0 0 0-1.375-.569l-.239-1.877A1.498 1.498 0 0 0 13.12 0h-2.24c-.757 0-1.396.567-1.486 1.317l-.239 1.88a9.307 9.307 0 0 0-1.375.569L6.286 2.605a1.488 1.488 0 0 0-1.979.122L2.732 4.301a1.49 1.49 0 0 0-.127 1.986l1.161 1.494a9.34 9.34 0 0 0-.569 1.374l-1.877.239C.567 9.484 0 10.123 0 10.88v2.24c0 .757.567 1.396 1.317 1.486l1.88.239c.155.477.346.937.569 1.374l-1.161 1.495a1.486 1.486 0 0 0 .122 1.979l1.575 1.575a1.492 1.492 0 0 0 1.985.126l1.494-1.161c.437.224.897.415 1.374.569l.239 1.876c.09.755.729 1.322 1.486 1.322h2.24c.757 0 1.396-.567 1.486-1.317l.239-1.88a9.45 9.45 0 0 0 1.374-.569l1.495 1.161c.605.47 1.459.415 1.979-.122l1.575-1.575a1.49 1.49 0 0 0 .127-1.985l-1.161-1.494c.224-.437.415-.897.569-1.374l1.876-.239a1.498 1.498 0 0 0 1.32-1.486v-2.24a1.496 1.496 0 0 0-1.316-1.486zM12 17c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z" fill="#ffffff"/>
</svg>

<span className="ms-2">Invoice Setting</span>
                </p></span></Link>
          </li>
          : ''}

        <li>
          {/* 
          <SidebarMenuToggle className="text-white" onClick={() => setShow7(!show7)}>
            <p>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
              </svg><span className="ms-2">About Us</span></p>
          </SidebarMenuToggle> */}
          {/* {show7 ?
            <ul className="sidesubmenu">

              <li>
                <Link className="dropdown-toggle let"><p>
                    <span className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>About PetroSmart</span></p></Link>

              </li>
              <li>
                <Link className="dropdown-toggle let"><p>
                    <span className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Privacy policies</span></p></Link>
              </li>
            </ul>
            : <a onClick={() => setShow7(show7)}></a>} */}
        </li>

      </ul>
      {/* <a href="#" className="btm-corner"><strong><i className="fa fa-question-circle-o p-2"></i>Help</strong></a> */}
    </div>
  )


}


export default Operational_Sidebar_Progress;
export const convertAmountToWords = (e, nums) => {

  var parent = e.currentTarget.parentNode
  var selector = parent.querySelector('.amount-words')
  if (typeof selector !== 'undefined' && selector) {

    var a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
    var b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    var myArr = nums.split(".");
    var num = myArr[0];
    var num1 = myArr[1] ? myArr[1] : '';
    if ((num = num.toString()).length > 9) return 'overflow';
    /****************************/
    var n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);

    if (!n) return; var str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';
    str += (n[5] != 0) ? ((str != '') ? 'And ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + ' ' : '';
    // var selector = document.getElementsByClassName('amount-words')
    /************************* */
    if (num1 != '') {
      if ((num1 = num1.toString()).length > 2) return 'overflow';
    }

    /****************************/
    var p = ('000000000' + num1).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);

    var str1 = '';
    if ((p) && (num1 != '')) {
      str1 += (p[5] != 0) ? ((str1 != '') ? 'And ' : '') + (a[Number(p[5])] || b[p[5][0]] + ' ' + a[p[5][1]]) + ' ' : '';
    }
    /************************* */

    if (str1 != '') {
      if (str == '') {
        str = 'Zero';
      }
      str = str + ' Rupees And ' + str1 + ' Paise ';
    }
    else if (str != '' && num != 1 && num != 0) {
      str = str + ' Rupees';
    }
    else if (num == 0 && str1 == '') {
      str = str + ' Zero';
    }
    else if (num == 1 && str1 == '') {
      str = str + ' Rupee';
    }
    selector.innerHTML = str;
  }



}

export const preventNonNumericalInput = (e, num) => {
  e = e || window.event;
  const charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
  const charStr = String.fromCharCode(charCode);
  const fullChar = num ? num.toString() + charStr : charStr;

  if (!/^\d*(\.\d{0,2})?$/.test(fullChar)) {
    e.preventDefault();
  }

  const [integerPart] = fullChar.split('.');
  if (integerPart.length > 8) {
    e.preventDefault();
  }
}

// export const prevNonNumericalWithDec = (e, num) => {

//   var parent = e.currentTarget.parentNode
//   var selector = parent.querySelector('.ph_no')
//   if (typeof selector !== 'undefined' && selector) {
//     e = e || window.event;
//     var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
//     var charStr = String.fromCharCode(charCode);
//     var fullChar = num ? num?.toString() + charStr : charStr;
//     if (!fullChar.match(/^[0-9]+$/))
//       e.preventDefault();
//   }
//   else {
//     e = e || window.event;
//     var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
//     var charStr = String.fromCharCode(charCode);
//     var fullChar = num ? num?.toString() + charStr : charStr;
//     if (!fullChar.match(/^[0-9]+$/))
//       e.preventDefault();

//     var myArr = fullChar.toString().split('.');
//     var num0 = myArr[0];
//     if ((num0 = num0.toString()).length > 8)
//       e.preventDefault();

//   }
// }


// export const prevNonNumericalWithDec = (e, num) => {
//   e = e || window.event;
//   const charCode = typeof e.which === "undefined" ? e.keyCode : e.which;
//   const charStr = String.fromCharCode(charCode);
//   const fullChar = num ? num.toString() + charStr : charStr;

//   // Regular expression to allow only numbers and one decimal point
//   const regex = /^[0-9]*\.?[0-9]*$/;

//   // If input contains more than one decimal or doesn't match the regex, prevent input
//   if (!regex.test(fullChar) || (charStr === '.' && num.includes('.'))) {
//     e.preventDefault();
//     return;
//   }

//   // Prevent input if the integer part exceeds 8 characters
//   const [integerPart] = fullChar.split('.');
//   if (integerPart.length > 8) {
//     e.preventDefault();
//   }
// };
export const prevNonNumericalWithDec = (e, num, type = "default") => {
  e = e || window.event;
  const charCode = typeof e.which === "undefined" ? e.keyCode : e.which;
  const charStr = String.fromCharCode(charCode);

  if (type === "phone") {
    // Only allow numbers, prevent any other input
    if (!/^\d$/.test(charStr)) {
      e.preventDefault();
      return;
    }

    // Prevent input if the length exceeds 10 digits
    if (num.length >= 10) {
      e.preventDefault();
    }
    return;
  }

  // Invoice / bill numbers are identifiers, not amounts — allow up to the DB varchar(50).
  if (type === "invoice") {
    if (!/^\d$/.test(charStr)) {
      e.preventDefault();
      return;
    }
    if (String(num || "").length >= 50) {
      e.preventDefault();
    }
    return;
  }

  // Default behavior for numerical input with a decimal
  const fullChar = num ? num.toString() + charStr : charStr;

  // Regular expression to allow only numbers and one decimal point
  const regex = /^[0-9]*\.?[0-9]*$/;

  // If input contains more than one decimal or doesn't match the regex, prevent input
  if (!regex.test(fullChar) || (charStr === '.' && num.includes('.'))) {
    e.preventDefault();
    return;
  }

  // Prevent input if the integer part exceeds 8 characters
  const [integerPart] = fullChar.split('.');
  if (integerPart.length > 8) {
    e.preventDefault();
  }
};

export const prevDec = (e, num) => {

  e = e || window.event;
  var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
  var charStr = String.fromCharCode(charCode);
  var fullChar = num ? num?.toString() + charStr : charStr;

  if (!fullChar.match(/^[A-Za-z0-9_-]*$/)) {
    e.preventDefault();
  }

}
//var d = document.getElementsByClassName('hide-arrow')[0];
//if(typeof d !== 'undefined')
//{

//document.getElementsByClassName('hide-arrow')[0].addEventListener('keyup', function(event){

// alert(4546);

//});
//}
